var DomainEventType = function(params){
    var self = this;
    self.type = ko.observable(params && params.type || 0);
    self.label = ko.observable(params && params.label || '');

    self.selected = ko.observable(!!(params && params.selected || false));

    self.isSelected = function() {
        return !!self.selected();
    };

    self.toggleSelection = function() {
        self.selected(!self.selected());
    };
};
